export default class URLUploadMiddleware {

  constructor(opts) {
    this.opts = opts
  }

  parseRequestForURLUpload(origData) {

    const url = []
    const data = {}

    Object.keys(origData)
      .forEach((attr) => {
        if (this.opts.attrKeys.indexOf(attr) >= 0) {
          url.push(origData[attr])
        }
        else {
          data[attr] = origData[attr]
        }
      })

    if (data.urlPreview) {
      delete data.urlPreview
    }

    return {
      data,
      url
    }

  }

  request(opts) {

    if (opts.data && 'url' in opts.data && opts.data.url) {

      const {
        data,
        url
      } = this.parseRequestForURLUpload(opts.data)

      return {
        ...opts,
        data: {
          json: JSON.stringify(data),
          url
        }
      }

    }

    return opts

  }

}



// WEBPACK FOOTER //
// ./src/shared/api/middleware/url-upload.js